import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import addUserValidation from "../../constant/validations/form.validation.messages";

const validation = Yup.object().shape({
  role: Yup.string().required("Please Enter Role*"),
});

export default { resolver: yupResolver(validation) };
